/* global NDEFReader */
import React, { useState } from "react";

function NFCReader() {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const readNfc = async () => {
    try {
      if ("NDEFReader" in window) {
        const ndef = new NDEFReader();
        await ndef.scan();
        console.log("NFC scan started");

        ndef.onreading = (event) => {
          const decoder = new TextDecoder();
          for (const record of event.message.records) {
            const text = decoder.decode(record.data);
            setMessage(text);
          }
        };
      } else {
        setError("Web NFC not supported on this device.");
      }
    } catch (err) {
      setError("NFC reading error: " + err);
    }
  };

  return (
    <div>
      <button onClick={readNfc}>Read NFC</button>
      <p>Message: {message}</p>
      <p>{error}</p>
    </div>
  );
}

export default NFCReader;
